import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import {
  event_list_action,
  event_delete_action,
} from "../../../actions/master_actions/events_action";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../utils/Loader";
import { StatusActionId, clearSessionStorage, sessionExpireMessage, tokenInavlidMessage } from "../../../utils/constants";
import { fill_action } from "../../../actions/fillList_action";
import Header from "../../../common_components/Header";
import Pagination from "../../../utils/pagination";

class Event extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      userId: "",
      TypeOfEventID: "",
      Name: "",
      Status: "",
      Code: "",
      eventList: [],
      statusFillList: [],
      isAccordionExpanded: false,
      currentPage: 1,
    };
    this.navigateEventAdd = this.navigateEventAdd.bind(this);
    this.getEventsList = this.getEventsList.bind(this);
    this.navigateEventUpdate = this.navigateEventUpdate.bind(this);
    this.updateItem = this.updateItem.bind(this);
  }
  componentDidMount() {
    if (JSON.parse(sessionStorage.getItem("UserLoginData")) == null) {
      console.log("log");
      setTimeout(() => {
        this.props.navigate("/login");
      }, 500);
    }
    setTimeout(() => {
      {
        sessionStorage.getItem("roleId") == 4 ? (
          this.props.navigate("/checkList")
        ) : (
          <></>
        );
      }
    }, 10);
    const { userId } = this.state;
    this.setState({
      userId:
        sessionStorage.getItem("userId") == "" ||
        sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
    });
    this.getEventsList();
    this.getFillList(StatusActionId, userId, "", "");
  }

  navigateEventUpdate(TypeOfEventID, StatusID) {
    console.log(TypeOfEventID, StatusID);
    this.props.navigate("/events_add", {
      state: { TypeOfEventID: TypeOfEventID, StatusID: StatusID },
    });
  }

  navigateEventAdd() {
    const { eventList } = this.state;
    let maxCode = -1;
    eventList.forEach((event) => {
      const codeNumber = parseInt(event.Code.substring(2), 10);
      if (!isNaN(codeNumber) && codeNumber > maxCode) {
        maxCode = codeNumber;
      }
    });
    let newCode;
    if (maxCode < 9) {
      newCode = `TE0${maxCode + 1}`;
    } else {
      newCode = `TE${maxCode + 1}`;
    }

    this.props.navigate("/events_add", { state: { Code: newCode } });
  }

  getFillList(value, userId, keyword, keyvalue) {
    this.setState({ isLoading: true });
    this.props
      .fill_action(
        value,
        userId == "" || userId == null ? null : userId,
        keyword != "" ? keyword : null,
        keyvalue != "" ? keyvalue : null
      )
      .then((data) => {
        if (data.error != 1) {
          if (value == StatusActionId) {
            this.setState({ statusFillList: data.data, isLoading: false });
            console.log(data.data, "status");
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  getEventsList = async () => {
    const { userId, Name, Status } = this.state;
    this.setState({ isLoading: true });

    const finalStatus =
      Status == "InActive" ? 0 : Status == "Active" ? 1 : null;
    this.props
      .event_list_action(Name, finalStatus)
      .then((data) => {
        console.log(data);
        if (data.error !== 1) {
          // Sort the data by 'Code' property in ascending order
          data.data.sort((a, b) => a.Code.localeCompare(b.Code));

          this.setState({
            eventList: data.data,
            isLoading: false,
            currentpage: 1,
          });
        } else {
          if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
            //after session expire.....................
            sessionStorage.clear()
            this.props.navigate('/normalView')
            setTimeout(() => {
              toast.error(data.msg, {
                position:"top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
        }else{
          toast.error(data.msg, {
            position: "top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
        }}
      })
      .catch((e) => {
        console.log(e);
      });
    setTimeout(() => {
      console.log(this.state.eventList);
    }, 500);
  };

  handleDelete(TypeOfEventID) {
    const { userId } = this.state;
    const confirmed = window.confirm(
      "Are you sure you want to delete this Event?"
    );

    if (confirmed) {
      this.props
        .event_delete_action(TypeOfEventID)
        .then((data) => {
          if (data.error !== 1) {
            toast.success("Data Deleted Successfully", {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
            this.getEventsList(); // Refresh the holiday list after deletion
          } else {
            if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
              //after session expire.....................
              sessionStorage.clear()
              this.props.navigate('/normalView')
              setTimeout(() => {
                toast.error(data.msg, {
                  position:"top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
          }else{
            toast.error(data.msg, {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }}
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }
  updateItem(item) {
    this.setState({ currentPage: item });
  }
  eventRecord(eventList) {
    // const { userList } =this.state
    return (
      <table
        className="table table-bordered table-striped"
        id="dashboard-table"
      >
        <thead>
          <tr>
            <th class="text-center" style={{ width: "5%" }}>
              Event Code
            </th>
            <th style={{ width: "10%" }}>Event Name</th>
            <th class="text-center" style={{ width: "5%" }}>
              Status
            </th>
            <th className="text-center" style={{ width: "5%" }}>
              Action
            </th>
          </tr>
        </thead>
        <tbody id="myTable">
          {eventList != "" && eventList != null ? (
            eventList.map((item) => (
              <tr>
                <td class="text-center">{item.Code}</td>
                <td>{item.Name}</td>
                <td class="text-center">
                  {item.StatusID === 1 ? "Active" : "Inactive"}
                </td>
                <td class="text-center">
                  <a
                    href="javascript:void(0);"
                    onClick={() =>
                      this.navigateEventUpdate(
                        item.TypeOfEventID,
                        item.StatusID
                      )
                    }
                    title="Edit"
                    className="btn btn-sm"
                  >
                    <i className="fa fa-edit action_btn_table" />
                  </a>
                  {item.StatusID==1?(

                    <a
                    title="Delete"
                    className="btn btn-sm delete_record"
                    onClick={() => this.handleDelete(item.TypeOfEventID)}
                    >
                    <i className="fa fa-trash action_btn_table" />
                  </a>
                    ):<></>}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8">No data available</td>
            </tr>
          )}
        </tbody>
      </table>
    );
  }

  render() {
    const {
      isLoading,
      eventList,
      isAccordionExpanded,
      statusFillList,
      currentPage,
    } = this.state;
    const recordsPerPage = 10;
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    // Records to be displayed on the current page
    const currentRecords = eventList.slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const nPages = Math.ceil(eventList.length / recordsPerPage);
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <>
          <main id="main">
            <Header data={[21]} />

            <section style={{ marginTop: 115 }}>
              <div className="container-fluid">
                <div className="page-header">
                  <h4 className="page-title">List of Event</h4>
                  <div>
                    <a
                      href="javascript:void(0);"
                      onClick={() => this.navigateEventAdd()}
                      className="btn btn-primary btn-sm create_btn"
                    >
                      <span className="hidden-xs">Add</span>
                    </a>
                  </div>
                </div>
                <div className="search_accordion search_card">
                  <div className="panel-group" id="accordion">
                    <div className="panel panel-default">
                      <div
                        className="panel-heading accordion-toggle collapsed"
                        data-toggle="collapse"
                        data-parent="#accordion"
                        data-target="#collapseOne"
                        aria-expanded={isAccordionExpanded}
                        onClick={() =>
                          this.setState({
                            isAccordionExpanded: !isAccordionExpanded,
                          })
                        }
                      >
                        <h4 className="panel-title">Search:</h4>
                        <div className="searched_items">
                          <h5>
                            Event Name : <span>{this.state.Name}</span>
                          </h5>
                          <h5>
                            Status : <span>{this.state.Status}</span>
                          </h5>
                        </div>
                      </div>
                      <div
                        id="collapseOne"
                        className={`panel-collapse collapse ${
                          isAccordionExpanded ? "show" : ""
                        }`}
                        aria-labelledby="headingOne"
                      >
                        <div className="panel-body">
                          <div className="row mr_0">
                            <div className="col-md-2">
                              <div className="form-group">
                                <label>Event Name</label>
                                <input
                                  type="text"
                                  value={this.state.Name}
                                  onChange={(e) =>
                                    this.setState({ Name: e.target.value })
                                  }
                                  className="form-control search_form_control"
                                  placeholder="Enter Event Name"
                                />
                              </div>
                            </div>

                            <div className="col-md-2">
                              <div className="form-group">
                                <label>Status</label>
                                <select
                                  className="form-control"
                                  value={this.state.Status}
                                  onChange={(e) =>
                                    this.setState({ Status: e.target.value })
                                  }
                                >
                                  <option>Select Status</option>
                                  {statusFillList.length > 0
                                    ? statusFillList.map((data) => (
                                        <option
                                          key={data.Status}
                                          value={data.Status}
                                        >
                                          {data.Status}
                                        </option>
                                      ))
                                    : null}
                                </select>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <label>&nbsp;</label>
                              <button
                                onClick={() => this.getEventsList()}
                                className="btn btn-primary search_btn"
                              >
                                Search
                              </button>
                              &nbsp;
                              <button
                                onClick={() => {
                                  this.setState(
                                    {
                                      Status: "",
                                      Name: "",
                                      currentPage: 1,
                                    },
                                    () => this.getEventsList()
                                  );
                                }}
                                className="btn btn-primary search_btn"
                              >
                                Clear Filters
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="custom_table">
                  <div className="hack1">
                    <div className="hack2">
                      {this.eventRecord(currentRecords)}
                      {eventList.length > 0 ? (
                        <Pagination
                          nPages={nPages}
                          currentPage={currentPage}
                          setCurrentPage={this.updateItem}
                        />
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>

          <ToastContainer />
        </>
      </>
    );
  }
}
export default withRouter(
  connect(null, {
    event_list_action,
    event_delete_action,
    fill_action,
  })(Event)
);
